function objectWithoutProperties (obj, exclude) { var target = {}; for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k]; return target; }
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component"},[(_vm.wrapperElementTag)?_vm._l((_vm.visibleBlocks),function(ref,index){
var _uid = ref._uid;
var component = ref.component;
var rest = objectWithoutProperties( ref, ["_uid", "component"] );
var props = rest;
return _c(_vm.wrapperElementTag,_vm._b({key:_uid,tag:"Component"},'Component',_vm.wrapperElementAttrs[index],false),[_c(component,_vm._b({directives:[{name:"editable",rawName:"v-editable",value:(props),expression:"props"}],tag:"Component"},'Component',props,false))],1)}):_vm._l((_vm.visibleBlocks),function(ref){
var _uid = ref._uid;
var component = ref.component;
var rest = objectWithoutProperties( ref, ["_uid", "component"] );
var props = rest;
return _c(component,_vm._b({directives:[{name:"editable",rawName:"v-editable",value:(props),expression:"props"}],key:_uid,tag:"Component"},'Component',props,false))})],2)}
var staticRenderFns = []

export { render, staticRenderFns }